<template>
    <div class="pagination">
        <el-pagination
            v-if="totalCount > pageSize"
            class="pagination-page"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-size="pageSize"
            layout="->,prev, pager, next,  jumper, total"
            :total="totalCount"
            >
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'elPages',
    props: {
        pageSize: {
            type: Number,
            default: 10
        },
        pageIndex: {
            type: Number,
            default: 1
        },
        totalCount: {
            type: Number,
            default: 0
        }
    },
    methods: {
        handleCurrentChange(value) {
            this.$emit('currentChange', value)
        }
    }   
}
</script>
<style lang="stylus" scoped>
    .pagination {
        padding-right: 60px;
        &-page {
            margin-top: 20px;
            margin-bottom: 20px;
        }

        & >>> .el-pagination {
            .btn-next {
                width: 40px;
                height 40px;
                border-radius: 20px;
            }
            .btn-prev {
                width: 40px;
                height 40px;
                border-radius: 20px;
                margin-right: 11px;
            }

            .el-icon {
                font-size: 15px;
                color: #5c307d;
            }

            .el-pager li {
                width: 40px;
                height 40px;
                border-radius: 20px;
                font-size: 15px;
                line-height: 40px;
                margin-right: 11px;
                color: #5c307d;
            }

            .el-pager .active {
                color: #ffffff;
                background-color: #5c307d;
            }

            .el-pagination__jump {
                margin-left: 20px;
                font-size: 16px;
                margin-top: 5px;
            }

            .el-pagination__total {
                font-size: 16px;
                margin-left: 20px;
                margin-top: 5px;
            }

            .el-paginatioinput__innern__editor.el-input .el-input__inner {
                height: 40px;
                font-size 15px;
            }
        }
    }
</style>